/**
 * Export de portabilité RGPD (version Cloud) : droit d'accès à l'écran et messages d'erreur en français.
 * L'export lui-même est fourni par le serveur (`GET /v1/export/full`, `GET /v1/export/person/:id`).
 */
import type { ShellPerm } from '@application/access/ViewAccessPolicy';

/** Réservé à l'administrateur, et seulement dans le navigateur Cloud (l'API n'existe pas sur le poste). */
export function peutExporterRgpd(hoteCloudNavigateur: boolean, permission: ShellPerm): boolean {
  return hoteCloudNavigateur && permission === 'admin';
}

export const LIMITE_EXPORTS_RGPD = '10 exports par quart d’heure';

/** Message d'erreur lisible pour un refus du serveur (code HTTP) ou une erreur réseau. */
export function messageErreurExportRgpd(statut: number | undefined): string {
  switch (statut) {
    case 401:
      return 'Votre session a expiré. Reconnectez-vous puis recommencez.';
    case 403:
      return 'Cet export est réservé à l’administrateur de l’entreprise.';
    case 404:
      return 'Cette fiche est introuvable dans votre entreprise.';
    case 429:
      return `Trop d’exports demandés (${LIMITE_EXPORTS_RGPD} au maximum). Réessayez dans quelques minutes.`;
    default:
      return 'L’export a échoué. Vérifiez votre connexion et réessayez.';
  }
}
